//https://api.iconify.design/fa/play.svg
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  listeners: Element[] | (() => void)[]
  async connect() {
    this.setUpListeners()
  }
  disconnect() {
    this.cleanUpListeners()
  }

  cleanUpListeners() {
    if (this.listeners) this.listeners.forEach((l) => l())
  }

  setUpListeners() {
    const returns: (() => void)[] = []

    this.element.addEventListener('click', this.anchorListener)
    returns.push(() => this.element.removeEventListener('click', this.anchorListener))

    this.listeners = returns
  }

  anchorListener = (e: { target: any; preventDefault: () => void }) => {
    const valueUpdate = 'value_update='
    let target = e.target
    let href = target.getAttribute('href') || target.attributes.getNamedItem('href')

    while (!href) {
      target = target.parentElement

      if (target === this.element) break
      if (!target) break
      href = target.getAttribute('href') || target.attributes.getNamedItem('href')
    }

    if (!href) return

    const [actionCommand, userDataUpdates] = href.split('?')
    const [action, actionTarget] = actionCommand.split(':')

    if (href.startsWith(valueUpdate)) {
      e.preventDefault()
      const jsonData = decodeURIComponent(href.slice(valueUpdate.length))
      const data = JSON.parse(jsonData)

      this.dispatch('update', { detail: { updates: data } })
    }

    switch (action) {
      case 'open_popup': {
        e.preventDefault()
        const infoBoxName = decodeURIComponent(actionTarget)
        this.dispatch('info-box', { detail: { value: infoBoxName } })
        break
      }

      default:
        break
    }

    if (userDataUpdates) {
      const updates = userDataUpdates.split('&')
      const data = updates.reduce((acc, u) => {
        const [k, val] = u.split('=')
        const v = decodeURIComponent(val)
        try {
          acc[k] = JSON.parse(v)
        } catch (error) {
          acc[k] = v
        }
        return acc
      }, {})
      this.dispatch('update', { detail: { updates: data } })
    }
  }
}
